var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-box share-box-notebook pop" }, [
    _c("div", { staticClass: "pop-box" }, [
      _c("div", { staticClass: "pop-main" }, [
        _c("div", { staticClass: "share-body" }, [
          _c("div", { staticClass: "pop-title" }, [
            _c("i", { staticClass: "icon-share" }),
            _vm._v(" "),
            _c("span", { staticClass: "share-title" }, [
              _vm._v(_vm._s(_vm.$t("operation.share")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "share-options" }, [
            _c("span", { staticClass: "option-tips" }, [
              _vm._v(_vm._s(_vm.$t("operation.shareTimeLimit")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "option-items" }, [
              _c(
                "div",
                {
                  staticClass: "option-item",
                  class: { active: _vm.expireType == 0 },
                  on: {
                    click: function($event) {
                      return _vm.expireTypeSelect(0)
                    }
                  }
                },
                [_vm._v("3 " + _vm._s(_vm.$t("operation.hours")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-item",
                  class: { active: _vm.expireType == 1 },
                  on: {
                    click: function($event) {
                      return _vm.expireTypeSelect(1)
                    }
                  }
                },
                [_vm._v("24 " + _vm._s(_vm.$t("operation.hours")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-item",
                  class: { active: _vm.expireType == 2 },
                  on: {
                    click: function($event) {
                      return _vm.expireTypeSelect(2)
                    }
                  }
                },
                [_vm._v("30 " + _vm._s(_vm.$t("operation.days")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-item option-create",
                  on: { click: _vm.generateLink }
                },
                [_vm._v(_vm._s(_vm.$t("operation.createLink")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "share-result" }, [
              _c("div", { staticClass: "result result-link" }, [
                _c("span", { staticClass: "option-tips" }, [
                  _vm._v(_vm._s(_vm.$t("operation.shareLink")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shareResult.link,
                      expression: "shareResult.link"
                    }
                  ],
                  staticClass: "disable",
                  attrs: { type: "text", name: "shareLink" },
                  domProps: { value: _vm.shareResult.link },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.shareResult, "link", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "result result-pwd" }, [
                _c("span", { staticClass: "option-tips" }, [
                  _vm._v(_vm._s(_vm.$t("operation.password")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shareResult.pwd,
                      expression: "shareResult.pwd"
                    }
                  ],
                  staticClass: "disable",
                  attrs: { type: "text", name: "sharePwd" },
                  domProps: { value: _vm.shareResult.pwd },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.shareResult, "pwd", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "result result-copy" }, [
                _c("span", { staticClass: "option-tips" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "option-item copy-link",
                    class: { active: _vm.shareResult.link != "" },
                    on: { click: _vm.doCopy }
                  },
                  [_vm._v(_vm._s(_vm.$t("operation.copy")))]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "icon-close", on: { click: _vm.toCloseShareBox } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c19a180", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c19a180","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notebook/ShareBox.vue
// module id = null
// module chunks = 